import formatTableJson from '@/config/tableComponentParams.js'
import { deviceStatus, onOffLineStatus } from '@/config/status'
import { limitTimeStatusTag } from '@/config/tag.js'
import i18n from '@/locales/index'
export default formatTableJson([
  // {
  //   filed: 'name',
  //   label: '设备名称',
  //   width: '200px'
  // },
  {
    filed: 'code',
    label: i18n.t('Device.deviceCode'),
    width: '180px'
  },
  {
    filed: 'isInExpirationDate',
    label: i18n.t('Device.isInExpirationDate'),
    type: 'tag',
    colorList: limitTimeStatusTag,
    formatFn: function(_, row) {
      return row.inExpirationDateName
    }
  },
  {
    filed: 'customerName',
    label: i18n.t('Device.customerName'),
    width: '180px'
  },
  {
    filed: 'online',
    label: i18n.t('Device.onLineStatus'),
    type: 'status',
    statusProps: onOffLineStatus,
    renderFn(h, row) {
      return (
        <div style={'display:flex;'}>
          <img
            src={
              row.online === 'offline'
                ? require('@/assets/offline_WiFi.svg')
                : require('@/assets/online_WiFi.svg')
            }
            alt={''}
          />
          <span style={'marginLeft:4px'}>{row.onlineName || '-'}</span>
        </div>
      )
    }
  },
  {
    filed: 'state',
    label: i18n.t('Device.deviceStatus'),
    type: 'status',
    statusProps: deviceStatus,
    renderFn(h, row) {
      return <span>{row.online === 'online' ? row.stateName : '-'}</span>
    }
  },

  {
    filed: 'installationAreaName',
    label: i18n.t('Device.installationArea'),
    width: '300px',
    showOverflowTooltip: true,
    renderFn(h, row) {
      return (
        <div style={'display:flex;'}>
          <span style={'marginLeft:4px'}>{row.installationAreaName || '-'},</span>
          <span>{row.installationAreaDetail || '-'}</span>
        </div>
      )
    }
  },
  {
    filed: 'lastCommunicationTime',
    label: i18n.t('Common.lastCommunicationTime'),
    type: 'time',
    // sortable: true,
    width: '180px',
    showOverflowTooltip: true
  }
])
